import React from "react"
import moment from "moment"
import PlacesAutocomplete from 'react-places-autocomplete'
import cookie from "react-cookies"
import queryString from "query-string"
import { connect } from "react-redux"
import DateRangePicker from 'react-bootstrap-daterangepicker'
import { isIOS } from "react-device-detect"

import { setFilter, searchCarList, searchCarListMore } from "../../actions/carFindingAct"

import { init } from "../../model/car"
import { searchInHouse } from "../../model/common"

import { commonErr } from "../common/errors"
import { stypes, wdModes, wdTypes } from "../common/common";
import { parseAddressToLocation, parseAddressArrayToLocationArray, calculateDistance, validateWDMinHour, validateHourCityTour, initMap } from "../common/wdfunction"
import { MessageLine } from "../common/messagebox";

import Header from "../common/header"
import SideBar from "../common/sidebar"
import Filter from "./filter"
import ListView from "./listview"
import InfoWDType from "./infopopup"

import marker_0 from "../../static/img/marker-1.png";
import marker_1 from "../../static/img/marker-2.png";
import marker_2 from "../../static/img/marker-3.png";
import marker_3 from "../../static/img/marker-4.png";
import marker_4 from "../../static/img/marker-5.png";
import HereAutoComplete from "../common/hereautocomplete"


const defPriceRange = {
	min: 500,
	max: 10000,
	step: 100
};

const defLimitKMRange = {
	min: 0,
	max: 550,
	step: 50
};

const defLimitKMPriceRange = {
	min: 0,
	max: 15,
	step: 5
};

const defDPriceRange = {
	min: 0,
	max: 50,
	step: 5
};

const defFuelCRange = {
	min: 0,
	max: 30,
	step: 5
};

const defYearRange = {
	min: 2000,
	max: moment().year().valueOf(),
	step: 5
};

const defSeatRange = {
	min: 2,
	max: 16,
	step: 2
};

const defRadiusRange = {
	min: 5,
	max: 50,
	step: 3
}

const calendarTemplate = '<div class="daterangepicker dropdown-menu">' +
	'<div class="calendar left">' +
	'<div class="daterangepicker_input hidden">' +
	'<input class="input-mini form-control" type="text" name="daterangepicker_start" value="" />' +
	'<i class="fa fa-calendar glyphicon glyphicon-calendar"></i>' +
	'<div class="calendar-time">' +
	'<div></div>' +
	'<i class="fa fa-clock-o glyphicon glyphicon-time"></i>' +
	'</div>' +
	'</div>' +
	'<div class="calendar-table"></div>' +
	'</div>' +
	'</div>' +
	'</div>';

const bookingTimes = [];
for (var i = 0; i < 1440; i = i + 30) {
	const time = i;
	const hour = (time - time % 60) / 60;
	const hourLabel = hour < 10 ? `0${hour}` : `${hour}`;
	const min = time % 60;
	const minLabel = min < 10 ? `0${min}` : `${min}`;
	bookingTimes.push({ value: time, label: `${hourLabel}:${minLabel}` });
}

const placesAutocompleteStyle = {
	autocompleteContainer: {
		position: 'absolute',
		top: '100%',
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
		width: '100%',
		border: 'none',
		zIndex: '10000'
	},
	autocompleteItem: {
		backgroundColor: 'rgba(0, 0, 0, 0.7)',
		padding: '10px',
		color: '#f0f0f0',
		cursor: 'pointer',
		display: 'flex',
		justifyContent: 'flex-start',
		flexWrap: 'wrap'
	},
	autocompleteItemActive: {
		backgroundColor: '#6c6c6e',
		color: '#fffff',
	},
}

const preventDefault = e => e.preventDefault();
function is2ArrayEqual(ar1, ar2) {
	if (ar1.length !== ar2.length) return false
	for (let i = 0; i < ar1.length; i++) {
		if (ar1[i] !== ar2[i]) {
			return false
		}
	}
	return true
}

class CarFindingWD extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			errMsgBox: "",
			popupId: "",
			isShowConfirmPopup: false,

			locAddress: [],
			markerArr: [],
			startLocation: null,
			endLocation: null,
			directionsService: null,
			directionsRenderer: null,

	
			isOpenFilterBox: false,
		
	
			isOpenSearching: false,
			showSearchTime: true,
			isOpenAddressBox: false,

			location: props.location,
			oriUrl: window.location.href,

			wdOneWay: false,
			wdMode: wdModes.CITY_TOUR,
			showInfoWdType: false,
		}

		this.hourValidateResult = -2 // use in searchCar function, show/hide UI, -2: never be checked
		this.map = React.createRef()
	}

 
	// initMap(wdOneWay, refs, locAddress) {

	// 	var directionsService = new window.google.maps.DirectionsService;
	// 	var directionsRenderer = new window.google.maps.DirectionsRenderer({
	// 		polylineOptions: {
	// 			strokeColor: "#00a550",
	// 			strokeWeight: 3
	// 		},
	// 		suppressMarkers: true,

	// 	});
	// 	var directionsRendererBackOW = new window.google.maps.DirectionsRenderer({
	// 		polylineOptions: {
	// 			strokeColor: "#000",
	// 			strokeWeight: 3
	// 		},
	// 		suppressMarkers: true,

	// 	});
	// 	const map = this.map = new window.google.maps.Map(refs.map, {
	// 		center: {
	// 			lat: 10.8,
	// 			lng: 106.660172
	// 		},
	// 		zoom: 13,
	// 		mapTypeControl: false,
	// 		scrollwheel: false,
	// 		clickableIcons: false,
	// 		streetViewControl: false,
	// 		zoomControl: true,
	// 		zoomControlOptions: {
	// 			position: window.google.maps.ControlPosition.RIGHT_BOTTOM
	// 		}
	// 	})

	// 	directionsRenderer.setMap(map);
	// 	directionsRendererBackOW.setMap(map);

	// 	this.calculateAndDisplayRoute(wdOneWay, directionsService, directionsRenderer, directionsRendererBackOW, locAddress, map)

	// 	this.setState({
	// 		directionsRenderer: directionsRenderer,
	// 		directionsRendererBackOW: directionsRendererBackOW,
	// 		directionsService: directionsService,
	// 		map: map
	// 	})


	// }


	componentDidMount() {
		init().then(initResp => {
		
			// check valid cookie before set
			if (cookie.load("_mstarttswd") < moment().add(2, "hours").valueOf() || cookie.load("_mendtswd") < moment().add(2, "hours").valueOf()) {
				cookie.remove("_mstarttswd", { path: '/' });
				cookie.remove("_mendtswd", { path: '/' });
			}


			var startDate;
			var endDate;
			var addressArray;
			var wdMode;
			var wdOneWay;
			var startTime;
			var endTime;

			const { platformType } = this.props.appInit


			//overide filter by query params
			if (this.props.location && this.props.location.search) {
				const query = queryString.parse(this.props.location.search);

				if (query.startDate) {
					startDate = moment(query.startDate * 1);
					startTime = startDate.get("hour") * 60 + startDate.get("minute");
				}
				if (query.endDate) {
					endDate = moment(query.endDate * 1);
					endTime = endDate.get("hour") * 60 + endDate.get("minute");
				}

				if (query.address) {
					// get collection address string from prame query, split it to array
					addressArray = query.address.split(";")
					// address = addressArray[0]
				}

				if (query.wdMode) {
					wdMode = Number(query.wdMode) === wdModes.CITY_TOUR ? wdModes.CITY_TOUR  : wdModes.PROVINCE
				}

				if (query.wdOneWay) {
					wdOneWay = query.wdOneWay === "true" ? true : false
				}

				//GA tracking
				// if (query.utm_source) {
				// 	cookie.save("_utm_src", query.utm_source, { path: '/' });
				// 	cookie.save("_utm_src", query.utm_source, { path: '/', domain: '.mioto.vn' });
				// }
				// if (query.utm_ext) {
				// 	cookie.save("_utm_ext", query.utm_ext, { path: '/' });
				// 	cookie.save("_utm_ext", query.utm_ext, { path: '/', domain: '.mioto.vn' });
				// } else {
				// 	cookie.remove("_utm_ext", { path: '/' });
				// 	cookie.remove("_utm_ext", { path: '/', domain: '.mioto.vn' });
				// }
			}

			const cStartTs = cookie.load("_mstarttswd");
			if (cStartTs) {
				const cStartDate = moment(cStartTs * 1);
				startDate = cStartDate;
				startTime = startDate.get("hour") * 60 + startDate.get("minute");
			}

			const cEndTs = cookie.load("_mendtswd");
			if (cEndTs) {
				endDate = moment(cEndTs * 1);
				endTime = endDate.get("hour") * 60 + endDate.get("minute");
			}


			if (!(startDate && endDate)) {
				const timeInit = initResp.data.data;
				if (timeInit) {
					startDate = moment(timeInit.wdStartTime)
					endDate = moment(timeInit.wdEndTime)
					startTime = moment(timeInit.wdStartTime).get("hour") * 60 + moment(timeInit.wdStartTime).get("minute")
					endTime = moment(timeInit.wdEndTime).get("hour") * 60 + moment(timeInit.wdEndTime).get("minute")
				}
				if (addressArray) {
					this.setState({
						addressBanner: addressArray[0] !== "" && addressArray[0]
					});

				}

			}
			cookie.save("_mstarttswd", startDate.valueOf(), { path: '/' });
			cookie.save("_mendtswd", endDate.valueOf(), { path: '/' });

			const filter = {
				...this.props.carFinding.filter,

				platformType: platformType,
				startDate: startDate,
				endDate: endDate,
				startTime: startTime,
				endTime: endTime,
				stype: stypes.WD,
				minPrice: 100,
				maxPrice: 20000,
				dPrice: 20,
				wdMode: wdMode, 
				wdOneWay: wdOneWay,
				transmission: ""
			}

			this.setState({
				startDate: startDate,
				endDate: endDate,
				startTime: startTime,
				endTime: endTime,
				platformType: platformType,
				wdMode: wdMode, 
				wdOneWay: wdOneWay,
				baseFilter: { ...filter }
			});
			this.setFilter(filter);
			/*
					-priority use:
				+ url query
				+ cookie
				+ default props
			*/

			// get addressArray in cookie
			var cAddressArray = []
			
			const cRoutes = cookie.load("_mbizroutes"); //isCityTour, wddistance, wdlocation, isOneWay, wdDistanceBackOW


			if (cRoutes) {
				let wdLocations = cRoutes[2]
			
				let temp_array = wdLocations.split(",")

				if (cRoutes[3] === false && cRoutes[0] === 1) { 
					temp_array.splice(temp_array.length-1,1)
				}

				for (let i = 0; i < temp_array.length; i++) {
					let temp_array1 = temp_array[i].split("-")
					cAddressArray.push(Buffer.from(temp_array1[2], 'base64').toString())
				}
			}

		

			const { wdMinHourCT } = initResp.data.data

			// if cookie math url param, use cookie cache to fast
			if (addressArray && is2ArrayEqual(addressArray, cAddressArray)) {
				// use cookie

				if (cRoutes) {
					wdMode = cRoutes[0]
					let wdDistance = cRoutes[1]
					let wdLocations = cRoutes[2]
					wdOneWay = cRoutes[3]
					let wdDistanceBackOW = cRoutes[4]
					// split wdlocations

					let temp_array = wdLocations.split(",")
					let locationArray = []
					let addressArray = []

					if (!cRoutes[3] && cRoutes[0] === 1) { 
						temp_array.splice(temp_array.length-1,1)
					}

					for (let i = 0; i < temp_array.length; i++) {
						let temp_array1 = temp_array[i].split("-")
						locationArray.push({ lat: parseFloat(temp_array1[0]), lng: parseFloat(temp_array1[1]) })
						addressArray.push(Buffer.from(temp_array1[2], 'base64').toString())

					}
				

					if (wdMode === wdModes.CITY_TOUR) {

						let hourValidateResult = validateHourCityTour(startDate, endDate, wdMinHourCT)

						if (hourValidateResult === -1) {
							// search car

							this.setState({
								hourValidateResult: hourValidateResult,
								locAddress: [locationArray[0]]
							})

							const filter = {
								...this.props.carFinding.filter,
								platformType: platformType,
								addressArray,
								wdMode,
								lat: locationArray[0].lat,
								lng: locationArray[0].lng,
								locationArray,
								wdLocations: wdLocations.split(",")[0],
								wdDistance: 0,
								wdOneWay: false,
								wdDistanceBackOW: 0
							}


							this.setFilter(filter);
							this.searchCar(filter);


						} else {
							this.setState({
								err: commonErr.FAIL,
								errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
							});
						}

					} else {
						// search car
						let hourValidateResult = this.checkValidateTypeMinHour(wdDistance, startDate, endDate)
					
						if (hourValidateResult === -1) {


							this.setState({
								hourValidateResult: hourValidateResult,
								locAddress: locationArray
							})

							const filter = {
								...this.props.carFinding.filter,
								platformType: platformType,
								addressArray: addressArray,
								wdMode,
								lat: locationArray[0].lat,
								lng: locationArray[0].lng,
								locationArray,
								wdLocations,
								wdDistance,
								wdDistanceBackOW,
								wdOneWay: wdOneWay
							}

							this.setFilter(filter);
							this.searchCar(filter);
						} else {
							this.setState({
								err: commonErr.FAIL,
								errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
							});
						}

					}

				}

			}
			// use url query param if valid
			else if ((addressArray && addressArray.length > 0 && wdMode !== undefined) || (!addressArray)) {
				if (!addressArray) {
					//use props
					addressArray = this.props.carFinding.filter.addressArray
					wdMode = this.props.carFinding.filter.wdMode
				}
				if (wdMode === wdModes.CITY_TOUR) {

					let hourValidateResult = validateHourCityTour(startDate, endDate, wdMinHourCT)

					if (hourValidateResult === -1) {
						// parse location
						// make wdLocaion
						// search car
						searchInHouse(addressArray[0]).then((response) => {

							
							const loc = response.data.data.locations[0]
						
					
							let location = {lat: loc.lat, lng: loc.lon}

					
							// format wdLocations
							let wdLocations = location.lat + '-' + location.lng + '-' + Buffer.from(addressArray[0]).toString('base64')

							this.setState({
								hourValidateResult,
								locAddress: [location]
							})

							const filter = {
								...this.props.carFinding.filter,
								platformType: platformType,
								addressArray,
								wdMode,
								lat: location.lat,
								lng: location.lng,
								locationArray: [location],
								wdLocations,
								wdDistance: 0,
								wdOneWay: false,
								wdDistanceBackOW: 0
							}

							// save cooke:  iscity, wddistance, wdlocation, time
							cookie.save("_mbizroutes", [wdModes.CITY_TOUR, 0, wdLocations, false, 0], { path: '/' });


							this.setFilter(filter);
							this.searchCar(filter);
						})

					} else {
						this.setState({
							err: commonErr.FAIL,
							errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
						});
					}

				} else {
					//paerse location
					//compute distance
					parseAddressArrayToLocationArray(addressArray, (locationArray) => {
						calculateDistance(locationArray, wdOneWay, (distance, distanceBackOW) => {
							let hourValidateResult = this.checkValidateTypeMinHour(distance, startDate, endDate)
							if (hourValidateResult === -1) {
						

								let wdLocations = this.formatWDLocations(addressArray, locationArray, wdOneWay)

								this.setState({
									hourValidateResult: hourValidateResult,
									locAddress: locationArray
								})

								const filter = {
									...this.props.carFinding.filter,
									platformType: platformType,
									addressArray,
									wdMode,
									lat: locationArray[0].lat,
									lng: locationArray[0].lng,
									locationArray,
									wdLocations,
									wdDistance: distance,
									wdOneWay: wdOneWay, 
									wdDistanceBackOW: distanceBackOW
								}
								// save cooke:  iscity, wddistance, wdlocation, time
								cookie.save("_mbizroutes", [wdMode, distance, wdLocations, wdOneWay, distanceBackOW], { path: '/' });

								this.setFilter(filter);
								this.searchCar(filter);

							} else {
								
								this.setState({
									err: commonErr.FAIL,
									errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
								});
							}

						})
					})
				}
			}
		})
	
	}

	componentWillReceiveProps(props) {
		this.setState({
			isOpenSearching: props.carFinding.filter.isOpenSearching
		}, () => {
			this.checkTouchMove();
		})
	}

	initMap = (address) => {
		const { wdOneWay} = this.props.carFinding.filter;
		let { locAddress } = this.state; 

		if (locAddress.length > 0) {

			setTimeout(() => {
				initMap(wdOneWay, this.map, locAddress, true, '', 2);
			}, 1000)

			return;
		}

		if (address) {
			setTimeout(() => {
				initMap(wdOneWay, this.map, address, true, '', 2);
			}, 1000)
			return;
		}
	}

	// getMarkerImage(index) {
	// 	var pins = [marker_0, marker_1, marker_2, marker_3, marker_4]

	// 	var icon = {
	// 		url: pins[index],
	// 		size: new window.google.maps.Size(40, 50),
	// 		origin: new window.google.maps.Point(0, 0),
	// 		anchor: new window.google.maps.Point(17, 34),
	// 		scaledSize: new window.google.maps.Size(34, 44)
	// 	};
	// 	return icon

	// }

	// createMarker(latlng, map, index) {

	// 	var markerArr = this.state.markerArr

	// 	var marker = new window.google.maps.Marker({
	// 		position: latlng,
	// 		map: map,
	// 		icon: this.getMarkerImage(index),
	// 		title: this.props.carFinding.filter.addressArray[index]
	// 	});
	// 	var contentString = `<div>${this.props.carFinding.filter.addressArray[index]}</div>`;
	// 	var infowindow = new window.google.maps.InfoWindow({
	// 		content: contentString
	// 	});
	// 	marker.addListener('click', function () {
	// 		infowindow.open(map, marker);
	// 	});

	// 	markerArr.push(marker)

	// 	this.setState({
	// 		markerArr: markerArr
	// 	})

	// 	return marker

	// }

	calculateAndDisplayRoute = (wdOneWay, directionsService, directionsRenderer, directionsRendererBackOW, locAddress, map) => {
			let address = []
			if (locAddress instanceof Array) {
				address = locAddress
			} else {
				address = [locAddress]
			}
		
			this.setState({
				locAddress: address
			}, () => {
				this.initMap(address)
			})
	
	}

	checkValidateTypeMinHour = (distance, startDate, endDate) => {

		// const {wdMode, wdOneWay} = this.state;
		const { wdMode, wdOneWay } = this.props.carFinding.filter
		const {wdMinHourCT, wdMinHourOW, wdMinHour} = this.props.appInit.data 
		let result = -1;

		if(wdMode === wdModes.CITY_TOUR) {
			result = validateHourCityTour(startDate, endDate, wdMinHourCT)
		} else if (wdMode === wdModes.PROVINCE && wdOneWay) {
			result = validateWDMinHour(wdMinHourOW, distance, startDate, endDate)  
		} else {
			result = validateWDMinHour(wdMinHour, distance, startDate, endDate)
		}

		return result
	}

	checkTouchMove = () => {
		if (this.state.isOpenSearching) {
			window.addEventListener('touchmove', preventDefault, {
				passive: false
			});
		} else {
			window.removeEventListener('touchmove', preventDefault, {
				passive: false
			})
		}
	}




	setFilter = (filter) => {
		this.props.dispatch(setFilter(filter));
	}

	resetFilter = () => {
		const { startDate, endDate, addressArray, locationArray, lat, lng, minMiles, wdLocations, wdDistance, stype, wdDistanceBackOW, wdOneWay, wdMode } = this.props.carFinding.filter;
		const filter = {
			...this.state.baseFilter,
			startDate: startDate,
			endDate: endDate,
			addressArray: addressArray,
			locationArray,
			lat: lat,
			lng: lng,
			minMiles: minMiles,
			wdMode,
			wdLocations,
			wdDistance,
			stype,
			wdDistanceBackOW,
			wdOneWay
		}

		this.setFilter(filter);
		const allFeatures = this.state.customFilterConfig.allFeatures;
		for (var i = 0; i < allFeatures.length; ++i) {
			allFeatures[i].checked = false;
		}

		this.searchCar(filter);

	}

	searchCarList = (f) => {
		const filter = this.standarizeFilter(f);
		this.props.dispatch(searchCarList(filter));
	}

	searchCarListMore = (f) => {
		const filter = this.standarizeFilter(f);
		this.props.dispatch(searchCarListMore(filter));
	}


	standarizeFilter = (filter) => {
		const customFilterConfig = this.state.customFilterConfig;
		const minPrice = (customFilterConfig && customFilterConfig.wdMinPrice) ? customFilterConfig.wdMinPrice / 1000 : defPriceRange.min;
		const maxPrice = (customFilterConfig && customFilterConfig.wdMaxPrice) ? customFilterConfig.wdMaxPrice / 1000 : defPriceRange.max;
		const minLimitKM = (customFilterConfig && customFilterConfig.minLimitKM) ? customFilterConfig.minLimitKM : defLimitKMRange.min;
		const maxLimitKM = (customFilterConfig && customFilterConfig.maxLimitKM) ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
		const maxLimitKMPrice = (customFilterConfig && customFilterConfig.maxLimitKMPrice) ? customFilterConfig.maxLimitKMPrice / 1000 + 5 : defLimitKMPriceRange.max;
		// wd
		const maxDPrice = (customFilterConfig && customFilterConfig.wdMaxDeliveryPrice) ? customFilterConfig.wdMaxDeliveryPrice / 1000 : defDPriceRange.max;
		const minFuelC = (customFilterConfig && customFilterConfig.minFuelC) ? customFilterConfig.minFuelC : defFuelCRange.min;
		const maxFuelC = (customFilterConfig && customFilterConfig.maxFuelC) ? customFilterConfig.maxFuelC : defFuelCRange.max;
		const minSeat = (customFilterConfig && customFilterConfig.seatMin) ? customFilterConfig.seatMin : defSeatRange.min;
		const maxSeat = (customFilterConfig && customFilterConfig.seatMax) ? customFilterConfig.seatMax : defSeatRange.max;
		const minYear = (customFilterConfig && customFilterConfig.yearMin) ? customFilterConfig.yearMin : defYearRange.min;
		const maxYear = (customFilterConfig && customFilterConfig.yearMax) ? customFilterConfig.yearMax : defYearRange.max;
		const maxRadius = (customFilterConfig && customFilterConfig.maxRadius) ? customFilterConfig.maxRadius : defRadiusRange.max;
		return {
			...filter,
			minPrice: (filter.minPrice > minPrice) ? filter.minPrice : 0,
			maxPrice: (filter.maxPrice < maxPrice) ? filter.maxPrice : 0,
			dPrice: (filter.dPrice < maxDPrice) ? filter.dPrice : -1,
			limitKM: (filter.limitKM < maxLimitKM) ? filter.limitKM : -1,
			limitKMPrice: (filter.limitKM > minLimitKM && filter.limitKMPrice < maxLimitKMPrice) ? filter.limitKMPrice : -1,
			fuelC: (filter.fuelC > minFuelC && filter.fuelC < maxFuelC) ? filter.fuelC : 0,
			minSeat: (filter.minSeat > minSeat && filter.minSeat < maxSeat) ? filter.minSeat : 0,
			maxSeat: (filter.maxSeat > minSeat && filter.maxSeat < maxSeat) ? filter.maxSeat : 0,
			minYear: (filter.minYear > minYear && filter.minYear < maxYear) ? filter.minYear : 0,
			maxYear: (filter.maxYear > minYear && filter.maxYear < maxYear) ? filter.maxYear : 0,
			radius: (filter.radius * 1.60934 >= maxRadius) ? 0 : filter.radius
		}
	}

	searchCar = (filter) => {
			this.searchCarList(filter);
	}

	setAddressPlaceHolder = (msg) => {
		this.setState({
			addressPlaceHolder: msg
		});
	}

	onAddressChange = (address, i) => {
		let addr_temp = [...this.props.carFinding.filter.addressArray]
		addr_temp[i] = address
		const filter = {
			...this.props.carFinding.filter,
			addressArray: addr_temp,
			isOpenSearching: true
		}
		this.setFilter(filter);

	}

	onStartDateChange = (event, picker) => {
		event.preventDefault();
		if (picker.startDate) {
			const startDate = picker.startDate;
			var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;
			var endTime = endDate.get("hour") * 60 + endDate.get("minute");
			var hour = this.state.startTime ? (this.state.startTime - this.state.startTime % 60) / 60 : (this.props.carFinding.filter.startTime - this.props.carFinding.filter.startTime % 60) / 60;
			var minute = this.state.startTime ? this.state.startTime % 60 : this.props.carFinding.filter.startTime % 60;
			startDate.set({
				hour: hour,
				minute: minute,
				second: 0,
				milliseconds: 0
			});

			if (endDate <= startDate) {
				endDate = startDate.clone();
				endDate.add(23, "hour");
				endTime = moment(endDate).get("hour") * 60 + moment(endDate).get("minute");
			}

			//save cookies
			cookie.save("_mstarttswd", startDate.valueOf(), { path: '/' });
			cookie.save("_mendtswd", endDate.valueOf(), { path: '/' });

			this.setState({
				startDate: startDate,
				endDate: endDate,
				endTime: endTime,
			})

			this.toogleSearchTime();

			let hourValidateResult = this.checkValidateTypeMinHour(this.props.carFinding.filter.wdDistance, startDate, endDate)

			this.setState({
				hourValidateResult
			})


			const filter = {
				...this.props.carFinding.filter,
				isOpenSearching: true,
				startDate: startDate,
				endDate: endDate,
				// wd
				stype: stypes.WD,
			}

			this.setFilter(filter);
			this.toogleSearchTime();

			if (hourValidateResult === -1) {
				this.setState({
					err: commonErr.SUCCESS
				})

				this.searchCar(filter);
			} else {
				this.setState({
					err: commonErr.FAIL,
					errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
				});
			}

		}
	}

	onEndDateChange = (event, picker) => {
		event.preventDefault();
		if (picker.startDate && picker.endDate) {
			const startDate = picker.startDate;
			startDate.set({
				hour: (this.state.startTime - this.state.startTime % 60) / 60,
				minute: this.state.startTime % 60,
				second: 0,
				milliseconds: 0
			});
			const endDate = picker.endDate;
			endDate.set({
				hour: (this.state.endTime - this.state.endTime % 60) / 60,
				minute: this.state.endTime % 60,
				second: 0,
				milliseconds: 0
			});
			if (endDate < startDate) {
				return;
			}

			//save cookies
			cookie.save("_mstarttswd", startDate.valueOf(), { path: '/' });
			cookie.save("_mendtswd", endDate.valueOf(), { path: '/' });

			this.setState({
				startDate: startDate,
				endDate: endDate
			})

			this.toogleSearchTime();


			let hourValidateResult = this.checkValidateTypeMinHour(this.props.carFinding.filter.wdDistance, startDate, endDate)

			this.setState({
				hourValidateResult
			})


			const filter = {
				...this.props.carFinding.filter,
				isOpenSearching: true,
				startDate: startDate,
				endDate: endDate,
				stype: stypes.WD,
			}

			this.setFilter(filter);
			this.toogleSearchTime();

			if (hourValidateResult === -1) {
				this.setState({
					err: commonErr.SUCCESS
				})

				this.searchCar(filter);
			} else {
				this.setState({
					err: commonErr.FAIL,
					errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
				});
			}
		}
	}

	onStartTimeChange = (event) => {
		const time = event.target.value;
		const hour = (time - time % 60) / 60;
		const min = time % 60;
		var startDate = moment(this.state.startDate ? this.state.startDate : this.this.props.carFinding.filter.startDate).set({
			hour: hour,
			minute: min,
			second: 0,
			milliseconds: 0
		});

		var endDate = this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate;
		if (endDate && endDate.isValid() && endDate <= startDate) {
			endDate = startDate.clone().add(23, "hour");
		}

		cookie.save("_mstarttswd", startDate.valueOf(), { path: '/' });
		cookie.save("_mendtswd", endDate.valueOf(), { path: '/' });

		this.setState({
			startDate: startDate,
			startTime: startDate.get("hour") * 60 + startDate.get("minute"),
			endDate: endDate,
			endTime: endDate.get("hour") * 60 + endDate.get("minute"),
			err: commonErr.SUCCESS,
			errMsg: ""
		});


		let hourValidateResult = this.checkValidateTypeMinHour(this.props.carFinding.filter.wdDistance, startDate, endDate)

		this.setState({
			hourValidateResult
		})


		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: true,
			startDate: startDate,
			endDate: endDate,
			stype: stypes.WD
		}

		this.setFilter(filter);

		if (hourValidateResult === -1) {
			this.setState({
				err: commonErr.SUCCESS
			})

			this.searchCar(filter);
		} else {
			this.setState({
				err: commonErr.FAIL,
				errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
			});
		}
	}

	onEndTimeChange = (event) => {
		const time = event.target.value;
		const hour = (time - time % 60) / 60;
		const min = time % 60;
		var endDate = moment(this.state.endDate ? this.state.endDate : this.props.carFinding.filter.endDate).set({
			hour: hour,
			minute: min,
			second: 0,
			milliseconds: 0
		});

		var startDate = this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate;
		if (startDate && startDate.isValid() && endDate <= startDate) {
			startDate = endDate.clone().add(-23, "hour");
		}

		cookie.save("_mstarttswd", startDate.valueOf(), { path: '/' });
		cookie.save("_mendtswd", endDate.valueOf(), { path: '/' });

		this.setState({
			startDate: startDate,
			startTime: startDate.get("hour") * 60 + startDate.get("minute"),
			endDate: endDate,
			endTime: endDate.get("hour") * 60 + endDate.get("minute"),
			err: commonErr.SUCCESS,
			errMsg: ""
		});

		let hourValidateResult = this.checkValidateTypeMinHour(this.props.carFinding.filter.wdDistance, startDate, endDate)

		this.setState({
			hourValidateResult
		})


		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: true,
			startDate: startDate,
			endDate: endDate,
			// wd
			stype: stypes.WD,
		}

		this.setFilter(filter);
		// this.toogleSearchTime();

		if (hourValidateResult === -1) {
			this.setState({
				err: commonErr.SUCCESS
			})

			this.searchCar(filter);
		} else {
			this.setState({
				err: commonErr.FAIL,
				errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
			});
		}

	}

	onAddressFocus = (e, i) => {

		let addressArrayTemp = [...this.props.carFinding.filter.addressArray]
		addressArrayTemp[i] = ""
		let locationArrayTemp = [...this.props.carFinding.filter.locationArray]
		locationArrayTemp[i] = undefined
		this.setState({
			hourValidateResult: -1
		})
		const filter = {
			...this.props.carFinding.filter,
			addressArray: addressArrayTemp,
			locationArray: locationArrayTemp,
		}
		this.setFilter(filter);

	}

	onSelectAddress = (address, i) => {
		const { startDate, endDate } = this.state;
		let { wdMode, addressArray, locationArray, wdOneWay} = this.props.carFinding.filter
		const { wdMinHourCT } = this.props.appInit.data

		if (address.err < 0) {
			var errMsg = "";
			if (address.err === -200) {
				errMsg = "Bạn đã không cho phép trình duyệt truy cập vị trí hiện tại. Vui lòng cài đặt cho phép hoặc nhập địa chỉ.";
			} else {
				errMsg = "Không thể tìm thấy vị trí hiện tại của thiết bị. Vui lòng thử lại hoặc nhập địa chỉ.";
			}
			this.setState({
				err: commonErr.FAIL,
				errMsg: errMsg
			});
		} 

		if (address.err === commonErr.LOADING) {
			this.setState({
				err: commonErr.LOADING,
			})
		}

			this.setState({
				err: commonErr.SUCCESS,
			});

			let addressArrayTemp = [...addressArray]
			addressArrayTemp[i] = address.address
			// parse location

			parseAddressToLocation(address.address, address.lat, address.lng, (location) => {
				let locationArrayTemp = [...locationArray]
				locationArrayTemp[i] = location
			
				
	
				if (wdMode === wdModes.CITY_TOUR) {
					
					this.calculateAndDisplayRoute(wdOneWay, this.state.directionsService, this.state.directionsRenderer, this.state.directionsRendererBackOW, [locationArrayTemp[0]], this.state.map);
					
					this.setState({
						err: commonErr.SUCCESS,
						hourValidateResult: validateHourCityTour(startDate, endDate, wdMinHourCT)
					})


					// change cache
					let cRoutes = cookie.load("_mbizroutes")
					let cwdLocationArray = cRoutes[2].split(",")
					cwdLocationArray[0] = location.lat + '-' + location.lng + '-' + Buffer.from(address.address).toString('base64')
					cRoutes[2] = cwdLocationArray.join(",")
					
					cookie.save("_mbizroutes", cRoutes, { path: '/' });

					this.setFilter({
						...this.props.carFinding.filter,
						addressArray: addressArrayTemp, 
						locationArray: locationArrayTemp,
						wdLocations: cwdLocationArray[0],
						lat: location.lat,
						lng: location.lng,
					});

					let hourValidateResult = validateHourCityTour(startDate, endDate, wdMinHourCT)
					if (hourValidateResult === -1) {
						this.searchCar({
							...this.props.carFinding.filter,
							lat: locationArrayTemp[0].lat,
							lng: locationArrayTemp[0].lng,
							wdLocations: cwdLocationArray[0],
							wdDistance: 0,
							wdOneWay: false,
							wdDistanceBackOW: 0
						});

					} else {
						this.setState({
							err: commonErr.FAIL,
							errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
						});
					}

				}
				// if across province
				if (wdMode === wdModes.PROVINCE) {
					if (addressArrayTemp.includes("")) {

						this.setFilter({
							...this.props.carFinding.filter,
							addressArray: addressArrayTemp,
							locationArray: locationArrayTemp
						});
							
				
					} else {

						this.calculateAndDisplayRoute(wdOneWay, this.state.directionsService, this.state.directionsRenderer, this.state.directionsRendererBackOW, locationArrayTemp, this.state.map)

						calculateDistance(locationArrayTemp, wdOneWay, (distance, distanceBackOW) => {

							let hourValidateResult = this.checkValidateTypeMinHour(distance, startDate, endDate)

							let wdLocations = this.formatWDLocations(addressArrayTemp, locationArrayTemp, wdOneWay)
					
							this.setState({
								err: commonErr.SUCCESS,
								hourValidateResult,
								locAddress: locationArrayTemp,
							})

							const filter = {
								...this.props.carFinding.filter,
								lat: locationArrayTemp[0].lat,
								lng: locationArrayTemp[0].lng,
								addressArray: addressArrayTemp,
								locationArray: locationArrayTemp,
								wdLocations,
								wdDistance: distance,
								wdDistanceBackOW: distanceBackOW,
								wdOneWay,
							}
							this.setFilter(filter);
							// save cooke:  iscity, wddistance, wdlocation, wdOneWay, wdDistanceBackOW
							cookie.save("_mbizroutes", [wdMode, distance, wdLocations, wdOneWay, distanceBackOW], { path: '/' });

							if (hourValidateResult === -1) {
								
								this.searchCar(filter);

							} else {
								this.setState({
									err: commonErr.FAIL,
									errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
								});
							}

						})
					}
				}
				
			})
		
	}

	onRemoveStopPoint = (i) => {

		let { addressArray, locationArray, wdLocations, startDate, endDate, wdOneWay, wdMode } = this.props.carFinding.filter
		let addressArrayTemp = [...addressArray]
		addressArrayTemp.splice(i, 1)
		let locationArrayTemp = [...locationArray]
		locationArrayTemp.splice(i, 1)

			if (addressArrayTemp.includes("")) {
		
				this.setFilter({
					...this.props.carFinding.filter,
					addressArray: addressArrayTemp,
					locationArray: locationArrayTemp,
				});
			}
			else {
				// compute distance
				this.calculateAndDisplayRoute(wdOneWay, this.state.directionsService, this.state.directionsRenderer, this.state.directionsRendererBackOW, locationArrayTemp, this.state.map)
				calculateDistance(locationArrayTemp, wdOneWay, (distance, distanceBackOW) => {
					let hourValidateResult = this.checkValidateTypeMinHour(distance, startDate, endDate)
					// format wdLocations
					let wdLocations = ""
					for (let i = 0; i < addressArrayTemp.length; i++) {
						wdLocations += `${locationArrayTemp[i].lat}-${locationArrayTemp[i].lng}-${Buffer.from(addressArrayTemp[i]).toString('base64')}${i !== addressArrayTemp.length - 1 ? ',' : ''}`
					}
					this.setState({
						err: commonErr.SUCCESS,
						hourValidateResult,
						locAddress: locationArrayTemp
					})

					const filter = {
						...this.props.carFinding.filter,
						lat: locationArrayTemp[0].lat,
						lng: locationArrayTemp[0].lng,
						addressArray: addressArrayTemp,
						locationArray: locationArrayTemp,
						wdMode,
						wdLocations,
						wdDistance: distance,
						wdOneWay, 
						wdDistanceBackOW: distanceBackOW
					}
					this.setFilter(filter);
					// save cooke:  iscity, wddistance, wdlocation, time
					cookie.save("_mbizroutes", [wdMode, distance, wdLocations, wdOneWay, distanceBackOW], { path: '/' });

					if (hourValidateResult === -1) {
						this.searchCar(filter);
					} else {
						this.setState({
							err: commonErr.FAIL,
							errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
						});
					}

				})

			}
		
	}

	onAddStopPoint = () => {
		this.setState({
			err: commonErr.FAIL,
			errMsg: "Vui lòng nhập địa chỉ còn trống"
		});

		let { addressArray, locationArray } = this.props.carFinding.filter
		if (addressArray.length >= 4) return;

		const filter = {
			...this.props.carFinding.filter,
			addressArray: [...addressArray, ""],
			locationArray: [...locationArray, undefined]
		}
		this.setFilter(filter);

	}
		
	onWDModeChange = (wdMode) => {
		let { startDate, endDate } = this.state;
		let { addressArray, locationArray, wdOneWay, wdLocations } = this.props.carFinding.filter
		const { wdMinHourCT } = this.props.appInit;
		let addressArrayTemp;
		let locationArrayTemp;


	
		
		
		const filter = { 
			...this.props.carFinding.filter,
			wdMode: wdMode
		}

		this.setFilter(filter)
	
		if (wdMode === wdModes.CITY_TOUR) { 

			this.calculateAndDisplayRoute(wdOneWay, undefined, undefined, undefined, [locationArray[0]], '');

			if (addressArray.length > 1 && locationArray.length > 1) { 
				addressArrayTemp = addressArray.splice(0,1)
				locationArrayTemp = locationArray.splice(0,1)
			} else { 
				addressArrayTemp = addressArray;
				locationArrayTemp = locationArray;
			}

			

			let hourValidateResult = validateHourCityTour(startDate, endDate, wdMinHourCT)
		
			let wdLocations = `${locationArrayTemp[0].lat}-${locationArrayTemp[0].lng}-${Buffer.from(addressArrayTemp[0]).toString('base64')}`
	

			this.setState({
				hourValidateResult,
				locAddress: locationArrayTemp[0]
			})

			if (hourValidateResult === -1) {

					const filter = {
						...this.props.carFinding.filter,
						addressArray: addressArrayTemp,
						wdMode,
						lat: locationArrayTemp[0].lat,
						lng: locationArrayTemp[0].lng,
						locationArray: locationArrayTemp,
						wdLocations: wdLocations,
						wdDistance: 0,
						wdOneWay: false,
						wdDistanceBackOW: 0,
						stype: stypes.WD
					}

					// save cooke:  iscity, wddistance, wdlocation, time
					cookie.save("_mbizroutes", [wdModes.CITY_TOUR, 0, wdLocations, false, 0], { path: '/' });

					this.setFilter(filter);
					this.searchCar(filter);
	
		
			}  else {
				this.setState({
					err: commonErr.FAIL,
					errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
				});
			}
		}
		if (wdMode === wdModes.PROVINCE) {

			if(addressArray.length === 1) {

				addressArray.push("")
				locationArray.push(undefined)

				const filter = { 
					...this.props.carFinding.filter,
					addressArray: addressArray,
					locationArray: locationArray,
					wdMode
				}

				this.setFilter(filter)

			} else if(addressArray.length > 1 && locationArray.length > 1 && !addressArray.includes("")) { 

					this.calculateAndDisplayRoute(wdOneWay, this.state.directionsService, this.state.directionsRenderer, this.state.directionsRendererBackOW, locationArray, this.state.map)
					calculateDistance(locationArray, wdOneWay, (distance, distanceBackOW) => {

							let hourValidateResult = this.checkValidateTypeMinHour(distance, startDate, endDate)
							let wdLocations = this.formatWDLocations(addressArray, locationArray, wdOneWay)

							this.setState({
								hourValidateResult: hourValidateResult,
								locAddress: locationArray
							})

							const filter = {
								...this.props.carFinding.filter,
								addressArray,
								wdMode,
								lat: locationArray[0].lat,
								lng: locationArray[0].lng,
								locationArray,
								wdLocations,
								wdDistance: distance,
								wdOneWay, 
								wdDistanceBackOW: distanceBackOW
							}
							// save cooke:  iscity, wddistance, wdlocation, time
							cookie.save("_mbizroutes", [wdMode, distance, wdLocations, wdOneWay, distanceBackOW], { path: '/' });

							this.setFilter(filter);
							if (hourValidateResult === -1) {
								this.searchCar(filter);
									
								} else { 
									this.setState({
										err: commonErr.FAIL,
										errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
									});
								}
						
					})
				}
			
			}

	

	}



	onWDWayCheckBoxChange = (e) => { 
		let { startDate, endDate } = this.state; 
		let { addressArray, locationArray, wdOneWay, wdMode } = this.props.carFinding.filter;
		
		if (!addressArray.includes("")) {
			this.calculateAndDisplayRoute(!wdOneWay, this.state.directionsService, this.state.directionsRenderer, this.state.directionsRendererBackOW, locationArray, this.state.map)

			calculateDistance(locationArray, !wdOneWay, (distance, distanceBackOW) => {
		
				let hourValidateResult = this.checkValidateTypeMinHour(distance, startDate, endDate)
				let wdLocations = this.formatWDLocations(addressArray, locationArray, !wdOneWay)

				this.setState({
					err: commonErr.SUCCESS,
					locAddress: locationArray,
					hourValidateResult: hourValidateResult
				})

				const filter = {
					...this.props.carFinding.filter,
					wdLocations: wdLocations,
					wdDistance: distance,
					wdDistanceBackOW: distanceBackOW,
					wdOneWay: !wdOneWay
				}
			
				this.setFilter(filter);

				// save cooke:  iscity, wddistance, wdlocation, time
				cookie.save("_mbizroutes", [wdMode, distance, wdLocations, !wdOneWay, distanceBackOW], { path: '/' });


				if (hourValidateResult === -1) {
				
					this.searchCar(filter);
			
				} else {
					this.setState({
						err: commonErr.FAIL,
						errMsg: `Thời gian thuê tối thiểu cho lộ trình trên là ${hourValidateResult} tiếng.`
					});
				}

			})
		} else {
			this.setState({
				err: commonErr.FAIL,
				errMsg: `Vui lòng nhập địa chỉ tìm kiếm`
			})
		}
		

	}


	showMessageBox = (msg) => {
		this.setState({
			errMsgBox: msg
		});
	}

	hideMessageBox = () => {
		this.setState({
			errMsgBox: ""
		});
	}

	togglePopup = (carGroupId) => {
		this.setState({
			popupId: carGroupId,
			isShowConfirmPopup: !this.state.isShowConfirmPopup,
		});
	}

	hideConfirm = () => {
		this.setState({
			isShowConfirmPopup: false,
		});
	}



	showAddressBox = () => {
		const { wdOneWay } = this.props.carFinding.filter

		if (this.state.locAddress.length > 0) {
			// setTimeout(() => {
			// 	this.initMap(wdOneWay, this.refs, this.state.locAddress);
			// }, 100)
			this.initMap()
		}

		this.setState({
			isOpenAddressBox: true
		})
	}

	hideAddressBox = () => {
		let { addressArray, wdMode } = this.props.carFinding.filter;
		let validAdress = wdMode === wdModes.CITY_TOUR ? addressArray[0] !== "" : !addressArray.includes("")
		if ( validAdress ) {
			this.setState({
				isOpenAddressBox: false
			})
		} else {
			this.setState({
				err: commonErr.FAIL,
				errMsg: "Vui lòng nhập địa chỉ tìm kiếm"
			})
		}
	}

	hasFilter = (filter, customFilterConfig) => {
		if (filter === undefined || customFilterConfig === undefined) {
			return false;
		}
		// const maxPrice = (customFilterConfig && customFilterConfig.maxPrice) ? customFilterConfig.maxPrice / 1000 : defPriceRange.max;
		const maxPrice = (customFilterConfig && customFilterConfig.wdMaxPrice) ? customFilterConfig.wdMaxPrice / 1000 : defPriceRange.max;
		const minPrice = (customFilterConfig && customFilterConfig.wdMinPrice) ? customFilterConfig.wdMinPrice / 1000 : defPriceRange.min;

		const maxLimitKM = (customFilterConfig && customFilterConfig.maxLimitKM) ? customFilterConfig.maxLimitKM + 50 : defLimitKMRange.max;
		const maxLimitKMPrice = (customFilterConfig && customFilterConfig.maxLimitKMPrice) ? customFilterConfig.maxLimitKMPrice / 1000 + 5 : defLimitKMPriceRange.max;
		// const maxDPrice = (customFilterConfig && customFilterConfig.maxDPrice) ? customFilterConfig.maxDPrice / 1000 : defDPriceRange.max;
		const maxDPrice = (customFilterConfig && customFilterConfig.wdMaxDeliveryPrice) ? customFilterConfig.wdMaxDeliveryPrice / 1000 : defDPriceRange.max;

		const minFuelC = (customFilterConfig && customFilterConfig.minFuelC) ? customFilterConfig.minFuelC : defFuelCRange.min;
		const minSeat = (customFilterConfig && customFilterConfig.seatMin) ? customFilterConfig.seatMin : defSeatRange.min;
		const maxSeat = (customFilterConfig && customFilterConfig.seatMax) ? customFilterConfig.seatMax : defSeatRange.max;
		const minYear = (customFilterConfig && customFilterConfig.yearMin) ? customFilterConfig.yearMin : defYearRange.min;
		const maxYear = (customFilterConfig && customFilterConfig.yearMax) ? customFilterConfig.yearMax : defYearRange.max;
		const maxRadius = (customFilterConfig && customFilterConfig.maxRadius) ? customFilterConfig.maxRadius : defRadiusRange.max;
		const sortValue = (customFilterConfig && customFilterConfig.sort) ? customFilterConfig.sort : "op";

		return filter.minPrice > minPrice
			|| filter.maxPrice < maxPrice
			|| filter.vehicleType != "0" || filter.vehicleMake != "0" || filter.vehicleModel != "0"
			|| filter.minSeat > minSeat || filter.maxSeat < maxSeat
			|| filter.minYear > minYear || filter.maxYear < maxYear
			|| filter.instantBooking === true || filter.directDelivery === true
			|| filter.dPrice < maxDPrice
			|| filter.transmission != "0"
			|| filter.features.length > 0
			|| filter.fuel != "0" || filter.fuelC > minFuelC
			|| filter.limitKM < maxLimitKM
			|| filter.limitKMPrice < maxLimitKMPrice
			|| filter.radius * 1.60934 < maxRadius
			|| filter.pVerified === true
			|| filter.sort != sortValue[0].id
			|| filter.supportIns === true
			|| filter.supportPassport === true
	}

	toggleSearching = () => {
		const { wdOneWay } = this.props.appInit.data

		if (this.state.isOpenSearching) {

			if (this.props.carFinding.filter.address == "") {
				const filter = {
					...this.props.carFinding.filter,
					address: this.state.addressBanner,
					isOpenSearching: false
				}
				this.setFilter(filter);
			}
		}

		if (this.state.locAddress.length > 0) {
			setTimeout(() => {
				this.initMap(wdOneWay, this.refs, this.state.locAddress);
			}, 100)

		}
		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: !this.state.isOpenSearching
		}
		this.setFilter(filter);

		this.setState({
			isOpenSearching: !this.state.isOpenSearching,
		}, () => {
			this.checkTouchMove();
			// this.checkOpenSearchBox();			
		});
	}

	toogleSearchTime = () => {
		this.setState({
			showSearchTime: !this.state.showSearchTime,
		})
	}

	checkOpenSearchBox = () => {
		const filter = {
			...this.props.carFinding.filter,
			isOpenSearching: this.state.isOpenSearching
		}
		this.setFilter(filter);
	}



	formatWDLocations = (address, location, wdOneWay) => { 
	
		let wdLocations = "";
	
		if (wdOneWay) { 
			for (let i = 0; i < address.length; i++) {
				wdLocations += `${location[i].lat}-${location[i].lng}-${Buffer.from(address[i]).toString('base64')}${i !== address.length - 1 ? ',' : ''}`
			}
		} else { 
			for (let i = 0; i < address.length; i++) {
				wdLocations += `${location[i].lat}-${location[i].lng}-${Buffer.from(address[i]).toString('base64')}${i !== address.length ? ',' : ''}`
			}
			wdLocations += `${location[0].lat}-${location[0].lng}-${Buffer.from(address[0]).toString('base64')}`
		}


		return wdLocations
	}


	changeAddressToRoute = () => {
		const { wdMode, addressArray } = this.props.carFinding.filter 
		if (wdMode === wdModes.CITY_TOUR) {
			return addressArray[0]
		}
		return addressArray.join(' - ')

	}

	showInfoWdType = () => {
		this.setState({
			showInfoWdType: true
		})
	}

	closeInfoWdType = () => {
		this.setState({
			showInfoWdType: false
		})
	}

	render() {

		var content;
		const { platformType } = this.props.appInit;
		const { startDate, endDate, isShowConfirmPopup, popupId, err, hourValidateResult, showInfoWdType} = this.state; 
		const { addressArray, wdOneWay, wdMode } = this.props.carFinding.filter;
		let wdType = wdMode === 0 ? wdTypes.CITY_TOUR : (wdMode === 1 && wdOneWay) ? wdTypes.ONEWAY : wdTypes.TWOWAY;
	

		if (err >= commonErr.SUCCESS) {

			content = <ListView platformType={platformType} startDate={startDate} endDate={endDate} stype={stypes.WD} show={isShowConfirmPopup} hideConfirm={this.hideConfirm} searchCarListMore={this.searchCarListMore} togglePopup={this.togglePopup} popupId={popupId} />

		} else {
			content = <div className="module-map">
				<div className="has-list">
					<div className="map-container">
						<MessageLine message={this.state.errMsg !== "" ? this.state.errMsg : "Đã có lỗi xảy ra. Vui lòng thử lại."} />
					</div>
				</div>
			</div>
		}


		return <div className="mioto-layout page-wrapper">
						<Header/>
						<SideBar />
						<div className="content-wrapper">
							<div className="page-content fade-in-up">
								<div className="ibox finding-control order-detail__sect" id="calendar-default">
									<div className="ibox-body">
										<div className="row">
											<div className="col-md-4">
												<div className="form-group d-flex location">
													<label className="inline-label">Lộ trình</label>
													<div className="wrap-input wrap-input-transparent r-map">
											<span className="route form-control form-control-line" onClick={this.showAddressBox}>{this.props.carFinding.filter.addressArray[0] !== "" ? this.changeAddressToRoute() : "Nhập địa chỉ"}</span>
													</div>
												</div>
											</div>
											{this.state.isOpenAddressBox && <div className="wd__sect wd-search__box" id="home-box">
												<div className="wd-search__wrap">
													<button className="close" type="button" onClick={this.hideAddressBox}>×</button>
													<div className="form-search location has-placeholder">
													
															<div className="map-route">
																<div ref={this.map} style={{ width: '100%', height: '300px', background: 'grey' }} />
															</div>

															<ul className="nav nav-tabs tabs-line tabs-line-2x nav-fill">
																<li className="nav-item">
																	<a className={`nav-link ${wdMode === wdModes.CITY_TOUR ? "active" : ""}`} onClick={() => this.onWDModeChange(wdModes.CITY_TOUR)}>Nội thành</a>
																</li>
																<li className="nav-item">
																	<a className={`nav-link ${wdMode === wdModes.PROVINCE ? "active" : ""}`}  onClick={() => this.onWDModeChange(wdModes.PROVINCE)}>Liên tỉnh</a>
																</li>
															</ul>

															<div className="tab-content">
																	{wdMode === wdModes.CITY_TOUR &&  <div id="cityTour" className={`w-100 tab-pane ${wdMode === wdModes.CITY_TOUR ? "fade show active" : ""}`}>
																		<label className="home-label">Điểm đón</label>
																		<div className="wrap-input input-group-icon input-group-icon-left">
																			<span className="input-icon input-icon-left"><i className="ic ic-start-location" /></span>
																			{/* <PlacesAutocomplete
																				classNames={{ input: "form-control form-control-line" }}
																				inputProps={{
																					value: addressArray[0],
																					onChange: (address) => this.onAddressChange(address, 0),
																					onFocus: (e) => this.onAddressFocus(e, 0),
																					placeholder: "Tôi muốn đón tại"
																				}}
																				styles={placesAutocompleteStyle}
																				onSelect={(address) => this.onSelectAddress(address, 0)}
																				isUseCurrentLocation={true}
																				googleLogo={false}
																				options={{ componentRestrictions: { country: ['vn'] } }}
																			/> */}
																			<HereAutoComplete 
																				styles={placesAutocompleteStyle}
																				onSelect={(address) => this.onSelectAddress(address, 0)}
																				focusAddress={true}
																				inputProps={{
																					value: addressArray[0],
																					onChange: (address) => this.onAddressChange(address, 0),
																					onFocus: (e) => this.onAddressFocus(e, 0),
																					placeholder: addressArray[0],
																				}} />
																		</div>
																		<p className="notice">Di chuyển xe trong thành phố. <a onClick={this.showInfoWdType} className="text-primary">Tìm hiểu thêm</a></p>
																	</div>}

																	{wdMode === wdModes.PROVINCE && <div id="province" className={`w-100 tab-pane ${wdMode === wdModes.PROVINCE ? "fade show active" : ""}`}>
																		<label className="home-label">Lộ trình</label>
																	
																		{addressArray.map((address, index) => {
																			return <div className="wrap-input input-group-icon input-group-icon-left" key={index}>
																				<span className="input-icon input-icon-left"><i className={index === 0 ? "ic ic-start-location" : "ic ic-sm-circle-fill"} /></span>
																					<div>
																					<HereAutoComplete 
																						
																						styles={placesAutocompleteStyle}
																						onSelect={(address) => this.onSelectAddress(address, index)}
																						focusAddress={true}
																						inputProps={{
																							value: addressArray[index],
																							onChange: (address) => this.onAddressChange(address, index),
																							onFocus: (e) => this.onAddressFocus(e, index),
																							placeholder: address
																						}} />
																						{/* <PlacesAutocomplete
																							classNames={{ input: "form-control form-control-line" }}
																							inputProps={{
																								value: address,
																								onChange: (address) => this.onAddressChange(address, index),
																								onFocus: (e) => this.onAddressFocus(e, index),
																								placeholder: index === 0 ? "Tôi muốn đón tại..." : "Tôi muốn đến..."
																						}}
																						styles={placesAutocompleteStyle}
																						onSelect={(address) => this.onSelectAddress(address, index)}
																						isUseCurrentLocation={index === 0}
																						googleLogo={false}
																						options={{ componentRestrictions: { country: ['vn'] } }}
																					/> */}
																				</div>
																				{!(index === 0 || index === 1) && <i onClick={() => this.onRemoveStopPoint(index)} className="fas fa-minus-circle" />}
																			</div>
																		})}
																		{!addressArray.includes("") && addressArray.length < 4  && <div className="wrap-input add-address" onClick={this.onAddStopPoint}><i className="fas fa-plus-circle mr-2" /><span>Thêm điểm đến</span></div>}

																		<div className="wrap-input add-address">
																			<label className="checkbox">
																				<input type="checkbox" onChange={this.onWDWayCheckBoxChange} checked={wdOneWay}/>
																				<span className="input-span" />
																				<span> Tôi muốn đi 1 chiều</span>
																			</label>
																		</div>

																		{wdOneWay ? <div className="info-way one-way wrap-input add-address"> 
																			<p className="notice">Di chuyển xe ngoài thành phố, di chuyển 1 chiều. <a onClick={this.showInfoWdType} className="text-primary">Tìm hiểu thêm</a></p> 
																		</div> 
																		: 
																		<div className="info-way two-way wrap-input add-address">
																			<p>
																				<i className="fas fa-flag mr-1"></i>
																				Trả xe tại điểm đón	
																			</p>
																			<p className="notice">Di chuyển xe ngoài thành phố, di chuyển 2 chiều. <a onClick={this.showInfoWdType} className="text-primary">Tìm hiểu thêm</a></p> 
																		</div>}
																		
																		{hourValidateResult > -1 ?
																				<div>
																					{!this.props.carFinding.filter.isCityTourMode && <div className="form-search total-addr mb-2">
																						<p className="home-label">Tổng lộ trình: <span className="total">{this.props.carFinding.filter.wdDistance ? `${this.props.carFinding.filter.wdDistance.toFixed(0)} Km` : '... Km'}</span>
																					</p> </div>}
																					<p className="text-danger">Thời gian thuê tối thiểu cho lộ trình trên là {hourValidateResult} tiếng.</p>
																				</div>
																				:
																				<div>
																					{this.props.carFinding.wd && this.props.carFinding.wd.distanceInKM > 0 && !this.props.carFinding.filter.addressArray.includes("") && <div className="form-search total-addr mb-2">
																						<p className="home-label">Tổng lộ trình: <span className="total">{this.props.carFinding.wd.distanceInKM ? `${this.props.carFinding.wd.distanceInKM.toFixed(0)} Km` : '... Km'}</span></p>
																					</div>}
																					{(this.props.carFinding.wd && this.props.carFinding.wd.limitKM > 0 && this.props.carFinding.filter.wdDistance !== null
																						&& (
																							(this.props.carFinding.filter.isCityTourMode && this.props.carFinding.filter.addressArray[0] !== "")
																							|| (!this.props.carFinding.filter.isCityTourMode && !this.props.carFinding.filter.addressArray.includes(""))
																						)
																					) && <div className="form-search total-addr mb-2">
																							<p className="home-label">Số km được đi: <span className="total">{this.props.carFinding.wd.limitKM ? `${this.props.carFinding.wd.limitKM.toFixed(0)} Km` : '... Km'}</span></p>
																						</div>}
																				</div>}			
																		</div>}
														
															</div>	
															<div className="text-center"><button className="btn btn-m btn-primary"  onClick={this.hideAddressBox}>Tìm kiếm</button></div>									
														</div>
													</div>
													<InfoWDType wdType={wdType} show={showInfoWdType} onHide={this.closeInfoWdType} />
												</div>}
											{this.state.showSearchTime && <div className="col-md-4">
											<div className="form-group d-flex location">
												<label className="inline-label">Bắt đầu</label>
												<div className="form-control form-control-line wrap-daterange">
													<DateRangePicker
														startDate={this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate}
														endDate={this.state.startDate ? this.state.startDate : this.props.carFinding.filter.startDate}
														minDate={moment()}
														maxDate={moment().add(3, "months")}
														timePicker={false}
														singleDatePicker={true}
														singleSelect={true}
														autoApply={true}
														isIOs={isIOS}
														timePickerIncrement={30}
														linkedCalendars={false}
														timePicker24Hour={true}
														onHide={this.onStartDateChange}
														buttonClasses={["hidden"]}
														opens={"center"}
														template={calendarTemplate}
														parentEl={"#calendar-default"}>
														<span className="value placeholder">{this.state.startDate ? this.state.startDate.format("DD/MM/YYYY") : (this.props.carFinding.filter.startDate ? this.props.carFinding.filter.startDate.format("DD/MM/YYYY") : "Chọn ngày")} <i className="i-chevron-down"></i></span>
													</DateRangePicker>
												</div>
												<div className="wrap-select">
													<select className="form-control form-control-line" onChange={this.onStartTimeChange} value={this.state.startTime ? this.state.startTime : this.props.carFinding.filter.startDate.get("hour") * 60 + this.props.carFinding.filter.startDate.get("minute")}>
														{bookingTimes.map(time => <option key={`s_${time.value}`} value={time.value}>{time.label} </option>)}
													</select>
													</div>
												</div>
										</div>}
											{this.state.showSearchTime && <div className="col-md-4">
															<div className="form-group d-flex location">
																<label className="inline-label">Kết thúc</label>
																<div className="form-control form-control-line wrap-daterange">
																	<DateRangePicker
																		startDate={this.props.carFinding.filter.startDate}
																		endDate={this.props.carFinding.filter.endDate}
																		minDate={moment(this.props.carFinding.filter.startDate.valueOf())}
																		maxDate={moment().add(3, "months")}
																		timePicker={false}
																		singleDateRangePicker={true}
																		singleSelect={true}
																		autoApply={true}
																		isIOs={isIOS}
																		timePickerIncrement={30}
																		linkedCalendars={false}
																		timePicker24Hour={true}
																		pickingEndDateOnly={true}
																		onHide={this.onEndDateChange}
																		buttonClasses={["hidden"]}
																		opens={"center"}
																		template={calendarTemplate}
																		parentEl={"#calendar-default"}>
																		<span className="value placeholder">{this.state.endDate ? this.state.endDate.format("DD/MM/YYYY") : (this.props.carFinding.filter.endDate ? this.props.carFinding.filter.endDate.format("DD/MM/YYYY") : "Chọn ngày")} <i class="i-chevron-down"></i></span>
																	</DateRangePicker>
																</div>
																<div className="wrap-select">
																	<select className="form-control form-control-line"  onChange={this.onEndTimeChange} value={this.state.endTime ? this.state.endTime : this.props.carFinding.filter.endDate.get("hour") * 60 + this.props.carFinding.filter.endDate.get("minute")}>
																		{bookingTimes.map(time => <option key={`e_${time.value}`} value={time.value}>{time.label} </option>)}
																	</select>
																</div>
															</div>
														</div>}
											</div>
											
										{this.state.isOpenAddressBox && <div className="search-filter-overlay" style={{ transition: "all .3s ease" }} onClick={this.hideAddressBox}></div>}
									</div>
								</div>
								<div className="row">
									<div className="col-md-3">
										<Filter filter={this.props.carFinding.filter} setFilter={this.setFilter} resetFilter={this.resetFilter} searchCar={this.searchCar} />
									</div>
									<div className="col-md-9">
										{content}
									</div>
								</div>	
							</div>
						</div>
					</div>
				
	}
}

function mapState(state) {
	return {
		appInit: state.appInit,
		carFinding: state.carFinding,
	}
}

CarFindingWD = connect(mapState)(CarFindingWD);
export default CarFindingWD;


// WEBPACK FOOTER //
// ./src/components/car/carfindingwd.js